export function applyFixedWidthFixes(config, dtInstance, $el) {
    const tableId = $el.attr('id') || `dt-${Math.random().toString(36).substr(2, 9)}`;

    $(window).off('resize.dt-refresh-' + tableId);
    if (!config.fixedColumns) return;

    let resizeTimer;
    $(window).on('resize.dt-refresh-' + tableId, () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if ($.contains(document, $el[0])) {
                if (typeof dtInstance.columns.adjust === 'function') {
                    dtInstance.columns.adjust();
                }
            } else {
                $(window).off('resize.dt-refresh-' + tableId);
            }
        }, 200);
    });
}
